import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getProductOrderDataRequest,
  getProductOrderDataSuccess,
  getProductOrderDataFailure,
  createProductOrderRequest,
  createProductOrderSuccess,
  createProductOrderFailure,
} from "./productOrderSlice";
import { toast } from "react-toastify";

function* fetchProductOrderData(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/getPendingOrder`
      )
    );

    if (response.data.success) {
      yield put(getProductOrderDataSuccess(response.data));
      toast.success(response.data.message);
    } else {
      yield put(
        getProductOrderDataFailure(
          response.data.message || "Failed to fetch productOrders"
        )
      );
      toast.error(response.data.message || "Failed to fetch productOrders");
    }
  } catch (error) {
    yield put(getProductOrderDataFailure(error.message));
    toast.error("Error fetching productOrders");
  }
}

function* createProductOrderSaga(action) {
  try {
    const token = localStorage.getItem("token");

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/createproductorder`,
        action.payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
    );

    if (response.data.success) {
      yield put(createProductOrderSuccess(response.data)); // <-- stores into productResponse
      toast.success(response.data.message);
    } else {
      yield put(createProductOrderFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(createProductOrderFailure(error.message));
    toast.error("Error creating product order");
  }
}

export function* productOrderSaga() {
  yield takeLatest(getProductOrderDataRequest.type, fetchProductOrderData);
  yield takeLatest(createProductOrderRequest.type, createProductOrderSaga);
}
